/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useReducer, useEffect, useState, Fragment } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Store } from "../Store";
import axios from "axios";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import ChatTwoToneIcon from "@mui/icons-material/QuestionAnswer";
import Modal from "@mui/material/Modal";
import LoadingBox from "../LoadingError/LoadingBox";
import { format, utcToZonedTime } from "date-fns-tz";
import { Combobox, Listbox, Transition } from "@headlessui/react";
import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

// Get user's timezone
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
// Map over the notifications and format the created_at timestamp
let formattedNotifications = null;

const options = [
  { id: 1, value: "post", name: "Post", unavailable: false },
  { id: 2, value: "user", name: "User", unavailable: false },
];

const Header = ({
  onChildStateChange,
  onChildStateChangeSearch,
  onChildStateChangePu,
  onSearchIconClick,
  onChildStateChangeSearchFlag,
}) => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElNotif, setAnchorElNotif] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [isClickedNotif, setIsClickedNotif] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [searchType, setSearchType] = useState("post");
  const [currentSwitch, setCurrentSwitch] = useState(1);
  const [showSignInModalNotif, setShowSignInModalNotif] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { shouldFetchNotifications } = state;
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const { userInfo } = state;
  const navigate = useNavigate();
  const locationMenu = useLocation();
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(options[0]);
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenNotifMenu = async (event) => {
    setAnchorElNotif(event.currentTarget);
    setIsClickedNotif(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/readNotif`,
        {},
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleProfileMenu = () => {
    navigate(`/${dataUser.username}`);
    setAnchorElUser(null);
  };

  const handleAboutUsMenu = () => {
    navigate("/about_us");
    setAnchorElUser(null);
  };

  const handleContactUsMenu = () => {
    navigate("/contact_us");
    setAnchorElUser(null);
  };

  const handleSignOutMenu = () => {
    signoutHandler();
    setAnchorElUser(null);
    navigate("/signin");
  };
  const handleCloseNotifMenu = () => {
    setAnchorElNotif(null);
    setIsClickedNotif(false);
  };

  const searchHandler = (e) => {
    e.preventDefault();
    onChildStateChangeSearchFlag(true);
  };

  const signoutHandler = (e) => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
  };

  const handleButtonClickSupply = () => {
    const newChildState = 1;
    setCurrentSwitch(1);
    onChildStateChange(newChildState);
  };

  const handleButtonClickDemand = () => {
    const newChildState = 2;
    setCurrentSwitch(2);
    onChildStateChange(newChildState);
  };

  const toggleModal = () => {
    setShowSignOutModal(!showSignOutModal);
  };

  const handleUserSuggestionClick = (suggestion) => {
    setSearchInput(suggestion.name);
    onChildStateChangeSearch(suggestion.name);
    setSearchSuggestions([]);
  };

  const handlePostSuggestionClick = (suggestion) => {
    setSearchInput(suggestion.posttitle);
    onChildStateChangeSearch(suggestion.posttitle);
    setSearchSuggestions([]);
  };

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     // Memicu pencarian setelah pengguna selesai mengetik selama beberapa waktu
  //     onChildStateChangeSearchFlag(true);
  //   }, 300); // Set waktu penundaan (misalnya: 500ms)

  //   // Membersihkan timer setelah setiap pembaruan nilai pencarian
  //   return () => {
  //     clearTimeout(delayDebounceFn);
  //   };
  // }, [searchInput]);

  const handleSearchTypeChange = (newSearchType) => {
    setSearchType(newSearchType.value);
    onChildStateChangePu(newSearchType.value === "post" ? "post" : "user");
  };

  function handleOpenPersonalChat(index) {
    navigate("/all_chat", {
      state: {
        allChat,
        chatIndex: index,
      },
    });
    setIsChatOpen(!isChatOpen);
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "FETCHING":
        return { ...state, loading: true };
      case "FETCHED":
        return { ...state, dataUser: action.payload, loading: false };
      case "FETCH_FAILED":
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };

  const reducer2 = (state, action) => {
    switch (action.type) {
      case "FETCHING":
        return { ...state, loadingChat: true };
      case "FETCHED":
        return { ...state, allChat: action.payload, loadingChat: false };
      case "FETCH_FAILED":
        return { ...state, loadingChat: false, errorChat: action.payload };
      default:
        return state;
    }
  };

  const reducer3 = (state, action) => {
    switch (action.type) {
      case "FETCHING":
        return { ...state, loadingNotif: true };
      case "FETCHED":
        return { ...state, allNotif: action.payload, loadingNotif: false };
      case "FETCH_FAILED":
        return { ...state, loadingNotif: false, errorNotif: action.payload };
      default:
        return state;
    }
  };

  const [{ dataUser }, dispatch] = useReducer(reducer, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ allChat }, dispatch2] = useReducer(reducer2, {
    allChat: [],
    loadingChat: true,
    errorChat: "",
  });

  const [{ allNotif, loadingNotif }, dispatch3] = useReducer(reducer3, {
    allNotif: [],
    loadingNotif: true,
    errorNotif: "",
  });

  useEffect(async () => {
    if (userInfo !== null) {
      dispatch2({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllChats`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch2({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch2({
          type: "FETCH_FAILED",
          payload: error.message,
        });
      }
    }
  }, [userInfo]);

  useEffect(async () => {
    if (userInfo !== null) {
      dispatch({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        if (error.response && error.response.status === 401) {
          signoutHandler();
          navigate("/signin");
        } else {
          toast.error(getError(error));
        }
      }
    }
  }, [navigate, userInfo]);

  //get notif
  useEffect(async () => {
    if (dataUser !== null && userInfo !== null) {
      dispatch3({
        type: "FETCHING",
      });

      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllNotif`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch3({
          type: "FETCHED",
          payload: data.data,
        });

        dispatch({ type: "RESET_FETCH_NOTIFICATIONS" });
      } catch (error) {
        dispatch3({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        console.log(error);
        dispatch({ type: "RESET_FETCH_NOTIFICATIONS" });
      }
    }
  }, [userInfo, shouldFetchNotifications]);

  useEffect(async () => {
    if (!allNotif.notifications) {
      return;
    }
    let newNotif = allNotif.notifications;

    formattedNotifications = newNotif.map((notification) => {
      const zonedTime = utcToZonedTime(
        new Date(notification.created_at),
        userTimezone
      );
      const formattedDate = format(zonedTime, "dd/MM/yyyy HH:mm", {
        timeZone: userTimezone,
      });
      return { ...notification, formatted_created_at: formattedDate };
    });
  }, [allNotif]);

  //filter clean
  useEffect(() => {
    if (searchType === "user") {
      onSearchIconClick(false);
    }
  }, [searchType]);

  function handleCloseSignInModalNotif() {
    setShowSignInModalNotif(false);
  }

  const handleCancelButtonModalNotif = () => {
    setShowSignInModalNotif(false);
  };

  function handleSignInButtonModalNotif() {
    setShowSignInModalNotif(false);
    navigate("/signin");
  }

  const handleAdminPageClick = () => {
    navigate("/admin_verified");
  };

  function SetProfilePicture() {
    const isNull = dataUser.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPP />;
    } else {
      return <ProfilePicture />;
    }
  }

  function DefaultPP() {
    return (
      <img
        className="w-[30px] h-[30px] rounded-full"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
        style={{ maxWidth: "50px", maxHeight: "50px" }}
      />
    );
  }

  useEffect(() => {
    const img = new Image();
    img.src = dataUser.picture;
    img.onload = () => setIsLoadingImg(false);
  }, [dataUser.picture]);

  function ProfilePicture() {
    return (
      <>
        {isLoadingImg ? (
          <div
            className={`w-[30px] h-[30px] rounded-full ${
              isLoadingImg ? "animate-pulse bg-slate-400" : ""
            }`}
          ></div>
        ) : (
          <img
            className="w-[30px] h-[30px] rounded-full"
            src={dataUser.picture}
            alt="profilepicture"
            referrerPolicy="no-referrer"
          />
        )}
      </>
    );
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onChildStateChangeSearchFlag(true);
  };

  // const ReadMore = ({ children }) => {
  //   const text = "This is a long text that exceeds 150 characters and will be truncated.";
  //   const [showMore, setShowMore] = useState(true);
  //   const toggleReadMore = () => {
  //     setShowMore(!showMore);
  //   };

  //   if (text.length <= 40) {
  //     return <p className="text-sm">" {text} "</p>;
  //   } else {
  //     return (
  //       <p className="text-sm">
  //         " {showMore ? text.slice(0, 40) + "..." : text}
  //         <span onClick={toggleReadMore} className="" style={readMoreStyle}>
  //           {showMore ? " read more" : " show less"}
  //         </span> "
  //       </p>
  //     );
  //   }
  // };

  const getNotificationLink = (notification) => {
    switch (notification.type) {
      case 1:
        return `/detail_post?postId=${notification.post_id}`;
      case 2:
        return `/detail_post?postId=${notification.post_id}`;
      case 3:
        return `/${notification.username}`;
      case 4:
        return `/all_chat`;

      case 5:
        return `/detail_post?postId=${notification.post_id}`;
      default:
        return "#";
    }
  };

  function handleCloseSignInModal() {
    setShowSignInModal(false);
  }

  function handleSignInButtonModal() {
    setShowSignInModal(false);
    navigate("/signin");
  }

  function handleCancelButtonModal() {
    setShowSignInModal(false);
  }

  function handleCloseSignOutModal() {
    setShowSignOutModal(false);
  }

  function handleCancelButtonSignOutModal() {
    setShowSignOutModal(false);
  }

  const SearchBox = ({
    searchType,
    onChildStateChangeSearch,
    onChildStateChangeSearchFlag,
  }) => {
    const [query, setQuery] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const [limitedSuggestions, setLimitedSuggestions] = useState(
      searchSuggestions.slice(0, 5)
    ); // Batasi hanya 5 item

    useEffect(() => {
      setLimitedSuggestions(searchSuggestions.slice(0, 5));
    }, [searchSuggestions]);

    const [selected, setSelected] = useState(limitedSuggestions[0]);

    const handleSearchOnChangeUser = async (e) => {
      // setSearchInput(e.target.value);
      // onChildStateChangeSearch(e.target.value);

      if (e.target.value.length > 1) {
        // Fetch suggestions only if input length is greater than 2
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/searchUser`,
            {
              params: { query: e.target.value }, // Send the input value as a query parameter
              auth: {
                username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
                password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
              },
            }
          );
          setSearchSuggestions(data.data);
        } catch (error) {
          console.error("Error fetching search suggestions:", error);
        }
      }
    };

    const handleSearchOnChangePost = async (e) => {
      // setSearchInput(e.target.value);
      // onChildStateChangeSearch(e.target.value);

      if (e.target.value.length > 1) {
        // Fetch suggestions only if input length is greater than 2
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/search`,
            {
              params: { query: e.target.value }, // Send the input value as a query parameter
              auth: {
                username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
                password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
              },
            }
          );

          setSearchSuggestions(data.data);
        } catch (error) {
          console.error("Error fetching search suggestions:", error);
        }
      }
    };
    const handleInput = async (e) => {
      const value = e.target.value;
      setSearchInput(value);
      if (searchType === "user") {
        await handleSearchOnChangeUser(e);
      } else {
        await handleSearchOnChangePost(e);
      }
    };

    const handleSearchSubmit = (valSearch) => {
      onChildStateChangeSearch(valSearch);
      onChildStateChangeSearchFlag(true);
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        const valSearch = e.target.value;

        handleSearchSubmit(valSearch);
      }
    };

    const handleSearchClick = () => {
      onChildStateChangeSearch(searchInput);
      onChildStateChangeSearchFlag(true);
    };

    const handleSuggestionClick = (e, suggestion) => {
      e.preventDefault();

      setSearchInput(
        searchType === "user" ? suggestion.name : suggestion.posttitle
      );
      onChildStateChangeSearch(
        searchType === "user" ? suggestion.name : suggestion.posttitle
      );
      onChildStateChangeSearchFlag(true);
    };

    const handleSuggestionKeyDown = (e, suggestion) => {
      if (e.key === "Enter") {
        setSearchInput(
          searchType === "user" ? suggestion.name : suggestion.posttitle
        );
        onChildStateChangeSearch(
          searchType === "user" ? suggestion.name : suggestion.posttitle
        );
        onChildStateChangeSearchFlag(true);
      }
    };

    function SetProfilePictureSuggestion({ person }) {
      const isNull = person.picture;
      if (isNull === "null" || isNull === null) {
        return <DefaultPPSuggestion />;
      } else {
        return <ProfilePictureSuggestion picture={person.picture} />;
      }
    }

    function DefaultPPSuggestion() {
      return (
        <img
          className="rounded-full w-8 h-8"
          src="../images/pp/defaultpp.png"
          alt="defaultprofilepicture"
          referrerPolicy="no-referrer"
        />
      );
    }

    function ProfilePictureSuggestion({ picture }) {
      return (
        <img
          className="rounded-full w-8 h-8"
          src={picture}
          alt="profilepicture"
          referrerPolicy="no-referrer"
        />
      );
    }

    return (
      <div className="w-[38vw] sm:w-full items-center relative">
        <Combobox
          as="div"
          value={selected}
          onChange={(value) => setSelected(value)}
          onClose={() => setSearchInput("")}
        >
          <div className="w-full rounded-lg focus:outline-none focus:border-[#F95C3D]">
            <Combobox.Input
              className={clsx(
                "w-full rounded-lg bg-white py-2 pr-3 pl-1 sm:pr-8 sm:pl-3 text-black text-xs sm:text-base",
                "focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25"
              )}
              style={{
                border: "0.1px solid gainsboro",
              }}
              onChange={
                !userInfo ? () => setShowSignInModal(true) : handleInput
              }
              value={searchInput}
              onKeyDown={handleKeyDown}
              placeholder="Search..."
            />
            <Combobox.Button
              className="group absolute inset-y-0 end-0 flex items-center z-20 px-2 cursor-pointer focus:outline-none focus:text-[#F95C3D]"
              onClick={() => {
                handleSearchClick();
              }}
            >
              <Tooltip title="Search">
                <SearchIcon className="text-black active:text-[#F95C3D]" />
              </Tooltip>
            </Combobox.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            {limitedSuggestions && (
              <Combobox.Options
                anchor="bottom"
                transition
                className={clsx(
                  "absolute mt-2 w-full rounded-lg bg-white shadow-2xl py-2 empty:invisible",
                  "transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0"
                )}
              >
                {limitedSuggestions.length > 0 ? (
                  limitedSuggestions.map((suggestion) => (
                    <Combobox.Option
                      key={suggestion.id}
                      value={suggestion}
                      className={({ active }) =>
                        `group flex cursor-pointer items-center gap-2 py-2 pr-3 pl-1 sm:pr-8 sm:pl-3 select-none text-black text-xs sm:text-base ${
                          active ? "bg-[#F5F5F5]" : ""
                        }`
                      }
                      onClick={(e) => {
                        handleSuggestionClick(e, suggestion);
                      }}
                      onKeyDown={(e) => {
                        handleSuggestionKeyDown(e, suggestion);
                      }}
                    >
                      {searchType === "user" ? (
                        <div>
                          <SetProfilePictureSuggestion person={suggestion} />
                        </div>
                      ) : null}
                      <div className="text-left">
                        {searchType === "user"
                          ? suggestion.name
                          : suggestion.posttitle}
                      </div>
                    </Combobox.Option>
                  ))
                ) : (
                  // <div className="text-black py-2 pr-8 pl-3">Type more </div>
                  <></>
                )}
              </Combobox.Options>
            )}
          </Transition>
        </Combobox>
      </div>
    );
  };

  const Select = () => {
    return (
      <div className="items-center relative mr-1 sm:mr-3">
        <Listbox
          as="div"
          // value={selected}
          onChange={
            !userInfo
              ? () => setShowSignInModal(true)
              : (value) => {
                  setSelected(value);
                  handleSearchTypeChange(value);
                }
          }
          onClose={() => setSelected("")}
        >
          <div className="w-full relative rounded-lg focus:outline-none focus:border-[#F95C3D] text-black">
            <Listbox.Button
              className={clsx(
                "w-full h-full rounded-lg bg-white py-2 pr-3 pl-1 sm:pr-8 sm:pl-3 text-black text-xs sm:text-base",
                "focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25"
              )}
              style={{
                border: "0.1px solid gainsboro",
              }}
            >
              {selected.name}
              <div className="absolute inset-y-0 end-0 flex items-center z-20 px-0 sm:px-2 cursor-pointer focus:outline-none ">
                <ChevronDownIcon
                  className=" h-3 w-3 sm:h-5 sm:w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
            </Listbox.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Listbox.Options
              anchor="bottom"
              transition
              className={clsx(
                "absolute w-full mt-2 rounded-lg bg-white shadow-2xl py-2 empty:invisible",
                "transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0"
              )}
            >
              {options.map((option) => (
                <Listbox.Option
                  key={option.id}
                  value={option}
                  disabled={option.unavailable}
                  className={({ active }) =>
                    `group flex cursor-pointer justify-center items-center gap-2 py-2 pr-2 pl-2 sm:pr-4 sm:pl-4 select-none text-black text-xs sm:text-base ${
                      active ? "bg-[#F5F5F5]" : ""
                    }`
                  }
                >
                  {option.name}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </Listbox>
      </div>
    );
  };

  return (
    <div>
      {/* Mobile Layout */}
      <div
        className={`${
          locationMenu.pathname === "/detail_post"
            ? // locationMenu.pathname === `/${dataUser.username}`
              "hidden"
            : "h-10 lg:hidden"
        }`}
      >
        <AppBar position="fixed" style={{ background: "white" }}>
          <Container maxWidth="xl" sx={{ px: "4px" }}>
            <Toolbar disableGutters>
              <Typography
                variant="h6"
                noWrap
                component="div"
                className="flex-none"
                fontFamily="unset"
              >
                <a
                  href="/"
                  className="font-bold"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <div className="flex items-center ">
                    <img
                      className="h-8 w-8 sm:h-10 sm:w-10 md:h-11 md:w-11 "
                      alt="siaphub logo"
                      src="../../images/siaphub_logo_clean.png"
                    />

                    <div className="text-gray-500 text-base md:text-lg font-bold hidden sm:flex">
                      SiapHub
                    </div>
                  </div>
                </a>
              </Typography>

              {(locationMenu.pathname === "/" ||
                locationMenu.pathname === "/search") && (
                <div className="flex-grow" style={{ textAlign: "center" }}>
                  <div style={{ textAlign: "center" }}>
                    {locationMenu.pathname !== "/search" ? (
                      <>
                        <button
                          onClick={handleButtonClickSupply}
                          className={
                            currentSwitch === 1
                              ? "border-orange-500 rounded-l-md p-1.5 text-orange-500 underline decoration-4 width-10 underline-offset-[20px] sm:underline-offset-[24px]"
                              : "border-orange-500 border-r-transparent rounded-l-md text-gray-500 p-1 hover:text-orange-500"
                          }
                        >
                          Share
                        </button>

                        <a className="ml-1 mr-1 border-l border-gray-500 h-8" />

                        <button
                          onClick={handleButtonClickDemand}
                          className={
                            currentSwitch === 2
                              ? "border-orange-500 rounded-r-md p-1.5 text-orange-500 underline decoration-4 width-10 underline-offset-[20px] sm:underline-offset-[24px]"
                              : "border-orange-500 border-l-transparent rounded-r-md text-gray-500 p-1 hover:text-orange-500"
                          }
                        >
                          Seek
                        </button>
                      </>
                    ) : (
                      <>
                        {!userInfo ? (
                          <>
                            <div className="flex justify-center">
                              <form
                                onClick={() => setShowSignInModal(true)}
                                className="flex items-center"
                              >
                                <Select />
                                <SearchBox
                                  searchType={searchType}
                                  onChildStateChangeSearch={
                                    onChildStateChangeSearch
                                  }
                                  onChildStateChangeSearchFlag={
                                    onChildStateChangeSearchFlag
                                  }
                                />
                              </form>
                              {searchType === "user" ? (
                                ""
                              ) : (
                                <div
                                  className="flex items-center ml-2 cursor-pointer "
                                  onClick={() => setShowSignInModal(true)}
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                                      isClicked ? "bg-[#FFE4CC]" : "none"
                                    }`}
                                  >
                                    <circle
                                      cx="15"
                                      cy="15"
                                      r="15"
                                      fill="none"
                                    />

                                    <path
                                      d="M17.9996 24.8777C18.0396 25.1777 17.9396 25.4976 17.7096 25.7076C17.6171 25.8003 17.5073 25.8738 17.3863 25.924C17.2653 25.9742 17.1357 26 17.0047 26C16.8738 26 16.7441 25.9742 16.6232 25.924C16.5022 25.8738 16.3923 25.8003 16.2998 25.7076L12.2904 21.6981C12.1813 21.5915 12.0984 21.4612 12.0481 21.3172C11.9978 21.1732 11.9815 21.0196 12.0004 20.8683V15.7489L7.21108 9.61978C7.04871 9.41134 6.97544 9.1471 7.00729 8.88481C7.03914 8.62252 7.17352 8.38349 7.38105 8.21997C7.57103 8.07999 7.781 8 8.00097 8H21.999C22.219 8 22.429 8.07999 22.6189 8.21997C22.8265 8.38349 22.9609 8.62252 22.9927 8.88481C23.0246 9.1471 22.9513 9.41134 22.7889 9.61978L17.9996 15.7489V24.8777ZM10.0407 9.99973L14.0001 15.059V20.5783L15.9999 22.578V15.049L19.9593 9.99973H10.0407Z"
                                      fill="black"
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="flex justify-center">
                              <form
                                onSubmit={handleSearchSubmit}
                                className="flex items-center"
                              >
                                <Select />

                                <SearchBox
                                  searchType={searchType}
                                  onChildStateChangeSearch={
                                    onChildStateChangeSearch
                                  }
                                  onChildStateChangeSearchFlag={
                                    onChildStateChangeSearchFlag
                                  }
                                />
                              </form>
                              {searchType === "user" ? (
                                ""
                              ) : (
                                <div
                                  className="flex cursor-pointer items-center"
                                  onClick={() => onSearchIconClick()}
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                                      isClicked ? "bg-[#FFE4CC]" : "none"
                                    }`}
                                  >
                                    <circle
                                      cx="15"
                                      cy="15"
                                      r="15"
                                      fill="none"
                                    />

                                    <path
                                      d="M17.9996 24.8777C18.0396 25.1777 17.9396 25.4976 17.7096 25.7076C17.6171 25.8003 17.5073 25.8738 17.3863 25.924C17.2653 25.9742 17.1357 26 17.0047 26C16.8738 26 16.7441 25.9742 16.6232 25.924C16.5022 25.8738 16.3923 25.8003 16.2998 25.7076L12.2904 21.6981C12.1813 21.5915 12.0984 21.4612 12.0481 21.3172C11.9978 21.1732 11.9815 21.0196 12.0004 20.8683V15.7489L7.21108 9.61978C7.04871 9.41134 6.97544 9.1471 7.00729 8.88481C7.03914 8.62252 7.17352 8.38349 7.38105 8.21997C7.57103 8.07999 7.781 8 8.00097 8H21.999C22.219 8 22.429 8.07999 22.6189 8.21997C22.8265 8.38349 22.9609 8.62252 22.9927 8.88481C23.0246 9.1471 22.9513 9.41134 22.7889 9.61978L17.9996 15.7489V24.8777ZM10.0407 9.99973L14.0001 15.059V20.5783L15.9999 22.578V15.049L19.9593 9.99973H10.0407Z"
                                      fill="black"
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}

              {
                // locationMenu.pathname === `/${dataUser.username}` ||
                // locationMenu.pathname === "/update_profile" ||
                // locationMenu.pathname === "/following_follower" ||
                // locationMenu.pathname === "/add_post" ||
                // locationMenu.pathname === "/about_us" ||
                // locationMenu.pathname === "/contact_us" ||
                // locationMenu.pathname === "/professional_account" ||
                // locationMenu.pathname === "/register_professional_account" ||
                // locationMenu.pathname === "/update_post" ||
                // locationMenu.pathname === "/detail_post" ||
                // locationMenu.pathname === "/all_chat" ||
                // locationMenu.pathname === "/admin_verified" ||
                // locationMenu.pathname === "/update_password" ||
                // locationMenu.pathname === "/privacy_policy" ||
                // locationMenu.pathname === "/terms_of_service" ||
                // locationMenu.pathname === "/edit_professional_account"
                !(
                  locationMenu.pathname === "/" ||
                  locationMenu.pathname === "/search"
                ) && (
                  <Box
                    sx={{ flexGrow: 1, display: { xs: "flex", lg: "none" } }}
                    className={`${
                      locationMenu.pathname === "/search"
                        ? "mb-3"
                        : "justify-center mb-3"
                    }`}
                  >
                    <></>
                  </Box>
                )
              }

              <div className="flex" style={{ alignItems: "center" }}>
                <div className="mobile-button flex">
                  {/* <div className="flex">
                    <Link
                      to="/about_us"
                      className={`flex mr-2 ${
                        locationMenu.pathname === "/about_us"
                          ? "bg-[#FFE4CC] text-[#F95C3D] rounded-lg"
                          : "text-black"
                      } `}
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                          locationMenu.pathname === "/about_us"
                            ? "bg-[#FFE4CC]"
                            : "none"
                        }`}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Link>

                    <Link
                      to="/contact_us"
                      className={`flex mr-2 ${
                        locationMenu.pathname === "/contact_us"
                          ? "bg-[#FFE4CC] text-[#F95C3D] rounded-lg"
                          : "text-black"
                      } `}
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                          locationMenu.pathname === "/contact_us"
                            ? "bg-[#FFE4CC]"
                            : "none"
                        }`}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Link>
                  </div> */}
                  {!userInfo ? (
                    <></>
                  ) : (
                    <>
                      <div className="flex ">
                        <Tooltip title="Notifications">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                              isClickedNotif ? "bg-[#FFE4CC]" : "none"
                            }`}
                            onClick={handleOpenNotifMenu}
                          >
                            <circle
                              cx="15"
                              cy="15"
                              r="15"
                              // fill={isClicked ? "#FFE4CC" : "none"}
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.0556 6.01266C16.0556 5.74408 15.9444 5.48651 15.7465 5.2966C15.5486 5.10669 15.2802 5 15.0003 5C14.7205 5 14.4521 5.10669 14.2542 5.2966C14.0563 5.48651 13.9451 5.74408 13.9451 6.01266V6.77215H13.3574C12.2262 6.77208 11.1375 7.18571 10.313 7.92885C9.48839 8.67198 8.98995 9.68875 8.91908 10.7722L8.68587 14.3509C8.59695 15.7154 8.11954 17.0303 7.30564 18.1524C7.13747 18.3844 7.03472 18.6541 7.00737 18.9355C6.98003 19.2169 7.02902 19.5002 7.14959 19.758C7.27015 20.0158 7.45819 20.2393 7.69541 20.4067C7.93263 20.5741 8.21095 20.6798 8.50332 20.7134L12.0985 21.1266V22.2152C12.0985 22.9538 12.4042 23.6621 12.9484 24.1843C13.4926 24.7066 14.2307 25 15.0003 25C15.77 25 16.5081 24.7066 17.0523 24.1843C17.5965 23.6621 17.9022 22.9538 17.9022 22.2152V21.1266L21.4974 20.7124C21.7896 20.6787 22.0677 20.573 22.3048 20.4057C22.5418 20.2383 22.7298 20.015 22.8503 19.7573C22.9708 19.4997 23.0199 19.2165 22.9927 18.9353C22.9655 18.654 22.8629 18.3844 22.695 18.1524C21.8811 17.0303 21.4037 15.7154 21.3148 14.3509L21.0816 10.7732C21.011 9.68958 20.5127 8.67256 19.6881 7.92922C18.8635 7.18587 17.7747 6.7721 16.6433 6.77215H16.0556V6.01266ZM13.3574 8.29114C12.6288 8.29105 11.9276 8.55744 11.3965 9.03606C10.8654 9.51468 10.5444 10.1695 10.4988 10.8673L10.2666 14.4461C10.1593 16.0876 9.58484 17.6694 8.60568 19.0192C8.59351 19.036 8.58607 19.0555 8.58408 19.0759C8.5821 19.0962 8.58563 19.1167 8.59434 19.1354C8.60305 19.154 8.61664 19.1702 8.63379 19.1823C8.65094 19.1944 8.67106 19.2021 8.69221 19.2046L12.6356 19.6592C14.2068 19.8395 15.7939 19.8395 17.3651 19.6592L21.3085 19.2046C21.3296 19.2021 21.3497 19.1944 21.3669 19.1823C21.384 19.1702 21.3976 19.154 21.4063 19.1354C21.415 19.1167 21.4186 19.0962 21.4166 19.0759C21.4146 19.0555 21.4072 19.036 21.395 19.0192C20.4162 17.6693 19.8421 16.0875 19.7351 14.4461L19.5019 10.8673C19.4563 10.1695 19.1352 9.51468 18.6042 9.03606C18.0731 8.55744 17.3719 8.29105 16.6433 8.29114H13.3574ZM15.0003 23.481C14.2722 23.481 13.6813 22.9139 13.6813 22.2152V21.4557H16.3194V22.2152C16.3194 22.9139 15.7284 23.481 15.0003 23.481Z"
                              fill={isClickedNotif ? "#F95C3D" : "black"}
                            />
                          </svg>
                        </Tooltip>
                        {allNotif.total_unread > "99" ? (
                          <span className="relative right-4 flex h-4 w-4">
                            <span className="flex rounded-full h-4 w-4 bg-[#F95C3D] text-[8px] text-white justify-center items-center">
                              99+
                            </span>
                          </span>
                        ) : allNotif.total_unread > "0" ? (
                          <span className="relative right-4 flex h-4 w-4">
                            <span className="flex rounded-full h-4 w-4 bg-[#F95C3D] text-[9.5px] text-white justify-center items-center">
                              {allNotif.total_unread}
                            </span>
                          </span>
                        ) : (
                          <div className="mr-4"></div>
                        )}
                      </div>

                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElNotif}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElNotif)}
                        onClose={handleCloseNotifMenu}
                        PaperProps={{
                          sx: {
                            borderRadius: "0.5rem",
                          },
                        }}
                      >
                        {loadingNotif && formattedNotifications !== "" ? (
                          <LoadingBox></LoadingBox>
                        ) : (
                          <>
                            {formattedNotifications &&
                            formattedNotifications.length === 0 ? (
                              <div className="mx-8 xl:mx-20">
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black hidden sm:flex"
                                >
                                  No Notifications!
                                </Typography>{" "}
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black flex sm:hidden"
                                  variant="body2"
                                >
                                  No Notifications!
                                </Typography>{" "}
                              </div>
                            ) : (
                              formattedNotifications &&
                              formattedNotifications.map((notification) => [
                                <MenuItem
                                  key={notification.id}
                                  onClick={handleCloseNotifMenu}
                                >
                                  <div className="flex-none">
                                    <img
                                      className="w-10 h-10 rounded-full mr-3"
                                      src={notification.picture}
                                      alt="defaultprofilepicture"
                                      referrerPolicy="no-referrer"
                                      style={{
                                        maxWidth: "50px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  </div>
                                  <Link
                                    to={getNotificationLink(notification)}
                                    className="w-full"
                                  >
                                    <Typography
                                      textAlign="left"
                                      className="no-underline text-black hidden sm:flex text-wrap"
                                      variant="body1"
                                    >
                                      {notification.type === 1
                                        ? `New Comment from ${notification.name} @${notification.username}`
                                        : notification.type === 2
                                        ? `New Like from ${notification.name} @${notification.username}`
                                        : notification.type === 3
                                        ? `${notification.name} @${notification.username} started following you`
                                        : notification.type === 4
                                        ? `New message from ${notification.name}`
                                        : notification.type === 5
                                        ? `New reply from ${notification.name}`
                                        : ""}
                                    </Typography>{" "}
                                    <Typography
                                      textAlign="left"
                                      className="no-underline text-black flex sm:hidden text-wrap"
                                      variant="body2"
                                    >
                                      {notification.type === 1
                                        ? `New Comment from ${notification.name} @${notification.username}`
                                        : notification.type === 2
                                        ? `New Like from ${notification.name} @${notification.username}`
                                        : notification.type === 3
                                        ? `${notification.name} @${notification.username} started following you`
                                        : notification.type === 4
                                        ? `New message from ${notification.name}`
                                        : notification.type === 5
                                        ? `New reply from ${notification.name}`
                                        : ""}
                                    </Typography>{" "}
                                    <div className="flex justify-between">
                                      <div className="truncate">
                                        {notification.notifmsg
                                          ? '"' + notification.notifmsg + '"'
                                          : ""}{" "}
                                      </div>
                                      <div className="text-sm sm:text-base">
                                        {notification.formatted_created_at}
                                      </div>
                                      {/* " {notification.notifmsg} "{" "}
                                      {notification.formatted_created_at} */}
                                    </div>
                                  </Link>
                                </MenuItem>,
                              ])
                            )}
                          </>
                        )}
                        {/* {loadingNotif && formattedNotifications !== "" ? (
                          <LoadingBox></LoadingBox>
                        ) : (
                          formattedNotifications.map((notification) => (
                            <MenuItem
                              key={notification.id}
                              onClick={handleCloseNotifMenu}
                            >
                              <Link
                                to={
                                  "/detail_post?postId=" + notification.post_id
                                }
                              >
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black"
                                >
                                  {notification.type == 1
                                    ? `New Comment from ${notification.name} @${notification.username}`
                                    : ""}
                                </Typography>{" "}
                                <div>
                                  " {notification.notifmsg} "{" "}
                                  {notification.formatted_created_at}
                                </div>
                              </Link>
                            </MenuItem>
                          ))
                        )} */}
                      </Menu>
                    </>
                  )}
                </div>

                <div className="mobile-button flex">
                  {!userInfo ? (
                    <Link to="/signin" className="text-orange-500">
                      SIGN IN
                    </Link>
                  ) : (
                    <IconButton
                      className="grow-0"
                      onClick={handleOpenUserMenu}
                      sx={{ p: 0 }}
                    >
                      <SetProfilePicture />
                    </IconButton>
                  )}
                </div>
              </div>
            </Toolbar>

            <div className="chat-history-dropdown">
              {isChatOpen && (
                <ul className="dropdown-menu">
                  {allChat.map((conversation, index) => (
                    <li key={conversation.chatid} className="conversation-item">
                      <div className="table-row">
                        <div className="table-col col-20">
                          {conversation.name}
                        </div>
                        <div className="table-col col-75">
                          {conversation.message}
                        </div>
                        <div className="table-col col-5">
                          <ChatTwoToneIcon
                            className="direct-chat-icon"
                            style={{
                              marginTop: "2.8vh",
                              marginLeft: "3vh",
                              color: "black",
                              fontSize: "4.1vh",
                              marginRight: "1vh",
                            }}
                            onClick={() => handleOpenPersonalChat(index)}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Container>
        </AppBar>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:flex">
        <AppBar position="fixed" style={{ background: "white" }}>
          <Container
            disableGutters
            maxWidth="2xl"
            className="flex"
            sx={{ px: "35px" }}
          >
            <Toolbar disableGutters>
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  // flexGrow: 0.1,
                  display: { xs: "none", md: "flex" },
                }}
                fontFamily="unset"
              >
                <a
                  href="/"
                  className="font-bold"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <div className="flex items-center ">
                    <img
                      className="h-12 w-12 "
                      alt="siaphub logo"
                      src="../../images/siaphub_logo_clean.png"
                    />
                    <div className="text-gray-500 font-bold">SiapHub</div>
                  </div>
                </a>
              </Typography>

              {
                // locationMenu.pathname === `/${dataUser.username}` ||
                // locationMenu.pathname === "/update_profile" ||
                // locationMenu.pathname === "/following_follower" ||
                // locationMenu.pathname === "/add_post" ||
                // locationMenu.pathname === "/about_us" ||
                // locationMenu.pathname === "/contact_us" ||
                // locationMenu.pathname === "/professional_account" ||
                // locationMenu.pathname === "/register_professional_account" ||
                // locationMenu.pathname === "/update_post" ||
                // locationMenu.pathname === "/detail_post" ||
                // locationMenu.pathname === "/all_chat" ||
                // locationMenu.pathname === "/admin_verified" ||
                // locationMenu.pathname === "/update_password" ||
                // locationMenu.pathname === "/privacy_policy" ||
                // locationMenu.pathname === "/terms_of_service" ||
                // locationMenu.pathname === "/edit_professional_account"
                (locationMenu.pathname === "/" ||
                  locationMenu.pathname === "/search") && (
                  <Box
                    sx={{
                      flexGrow: 1,
                      display: { xs: "none", md: "flex" },
                      justifyContent: `${
                        locationMenu.pathname === "/search"
                          ? "center"
                          : "center"
                      }`, // Center the content when pathname is '/search'
                      alignItems: "center", // Align items in the center vertically
                    }}
                    className={`${
                      locationMenu.pathname === "/search"
                        ? ""
                        : "justify-center"
                    }`}
                  >
                    {" "}
                    <div
                      className={`${
                        locationMenu.pathname === "/search" ? "hidden" : "ml-10"
                      }`}
                    >
                      <button
                        onClick={handleButtonClickSupply}
                        className={
                          currentSwitch === 1
                            ? " border-orange-500 rounded-l-md p-1.5 text-orange-500  underline decoration-4 width-10 underline-offset-[24px]"
                            : " border-orange-500 border-r-transparent rounded-l-md text-gray-500 p-1 hover:text-orange-500 "
                        }
                      >
                        Share
                      </button>

                      <a className="ml-3 mr-3 border-l border-gray-500 h-8" />

                      <button
                        onClick={handleButtonClickDemand}
                        className={
                          currentSwitch === 2
                            ? " border-orange-500 rounded-r-md p-1.5 text-orange-500 underline decoration-4 width-10 underline-offset-[24px]"
                            : " border-orange-500 border-l-transparent rounded-r-md text-gray-500 p-1 hover:text-orange-500 "
                        }
                      >
                        Seek
                      </button>
                    </div>
                    {locationMenu.pathname === "/search" ? (
                      <>
                        {!userInfo ? (
                          <>
                            <div>
                              <form
                                onClick={() => setShowSignInModal(true)}
                                className="flex items-center"
                              >
                                <Select />

                                <SearchBox
                                  searchType={searchType}
                                  onChildStateChangeSearch={
                                    onChildStateChangeSearch
                                  }
                                  onChildStateChangeSearchFlag={
                                    onChildStateChangeSearchFlag
                                  }
                                />
                              </form>
                            </div>
                            {searchType === "user" ? (
                              ""
                            ) : (
                              <div
                                className="ml-2 cursor-pointer "
                                onClick={() => setShowSignInModal(true)}
                              >
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                                    isClicked ? "bg-[#FFE4CC]" : "none"
                                  }`}
                                >
                                  <circle cx="15" cy="15" r="15" fill="none" />

                                  <path
                                    d="M17.9996 24.8777C18.0396 25.1777 17.9396 25.4976 17.7096 25.7076C17.6171 25.8003 17.5073 25.8738 17.3863 25.924C17.2653 25.9742 17.1357 26 17.0047 26C16.8738 26 16.7441 25.9742 16.6232 25.924C16.5022 25.8738 16.3923 25.8003 16.2998 25.7076L12.2904 21.6981C12.1813 21.5915 12.0984 21.4612 12.0481 21.3172C11.9978 21.1732 11.9815 21.0196 12.0004 20.8683V15.7489L7.21108 9.61978C7.04871 9.41134 6.97544 9.1471 7.00729 8.88481C7.03914 8.62252 7.17352 8.38349 7.38105 8.21997C7.57103 8.07999 7.781 8 8.00097 8H21.999C22.219 8 22.429 8.07999 22.6189 8.21997C22.8265 8.38349 22.9609 8.62252 22.9927 8.88481C23.0246 9.1471 22.9513 9.41134 22.7889 9.61978L17.9996 15.7489V24.8777ZM10.0407 9.99973L14.0001 15.059V20.5783L15.9999 22.578V15.049L19.9593 9.99973H10.0407Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <div>
                              <form
                                onSubmit={searchHandler}
                                className="flex items-center"
                              >
                                <Select />
                                <SearchBox
                                  searchType={searchType}
                                  onChildStateChangeSearch={
                                    onChildStateChangeSearch
                                  }
                                  onChildStateChangeSearchFlag={
                                    onChildStateChangeSearchFlag
                                  }
                                />
                              </form>
                            </div>
                            {searchType === "user" ? (
                              ""
                            ) : (
                              <div
                                className="ml-2 cursor-pointer "
                                onClick={onSearchIconClick}
                              >
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={`rounded-lg hover:bg-[#FFE4CC] active:scale-90 ${
                                    isClicked ? "bg-[#FFE4CC]" : "none"
                                  }`}
                                >
                                  <circle cx="15" cy="15" r="15" fill="none" />

                                  <path
                                    d="M17.9996 24.8777C18.0396 25.1777 17.9396 25.4976 17.7096 25.7076C17.6171 25.8003 17.5073 25.8738 17.3863 25.924C17.2653 25.9742 17.1357 26 17.0047 26C16.8738 26 16.7441 25.9742 16.6232 25.924C16.5022 25.8738 16.3923 25.8003 16.2998 25.7076L12.2904 21.6981C12.1813 21.5915 12.0984 21.4612 12.0481 21.3172C11.9978 21.1732 11.9815 21.0196 12.0004 20.8683V15.7489L7.21108 9.61978C7.04871 9.41134 6.97544 9.1471 7.00729 8.88481C7.03914 8.62252 7.17352 8.38349 7.38105 8.21997C7.57103 8.07999 7.781 8 8.00097 8H21.999C22.219 8 22.429 8.07999 22.6189 8.21997C22.8265 8.38349 22.9609 8.62252 22.9927 8.88481C23.0246 9.1471 22.9513 9.41134 22.7889 9.61978L17.9996 15.7489V24.8777ZM10.0407 9.99973L14.0001 15.059V20.5783L15.9999 22.578V15.049L19.9593 9.99973H10.0407Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </Box>
                )
              }

              {
                // locationMenu.pathname === `/${dataUser.username}` ||
                // locationMenu.pathname === "/update_profile" ||
                // locationMenu.pathname === "/following_follower" ||
                // locationMenu.pathname === "/add_post" ||
                // locationMenu.pathname === "/about_us" ||
                // locationMenu.pathname === "/contact_us" ||
                // locationMenu.pathname === "/professional_account" ||
                // locationMenu.pathname === "/register_professional_account" ||
                // locationMenu.pathname === "/update_post" ||
                // locationMenu.pathname === "/detail_post" ||
                // locationMenu.pathname === "/all_chat" ||
                // locationMenu.pathname === "/admin_verified" ||
                // locationMenu.pathname === "/update_password" ||
                // locationMenu.pathname === "/privacy_policy" ||
                // locationMenu.pathname === "/terms_of_service" ||
                // locationMenu.pathname === "/edit_professional_account"
                !(
                  locationMenu.pathname === "/" ||
                  locationMenu.pathname === "/search"
                ) && (
                  <Box
                    sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
                    className={`${
                      locationMenu.pathname === "/search"
                        ? "mb-3"
                        : "justify-center mb-3"
                    }`}
                  >
                    <></>
                  </Box>
                )
              }
              <div className="flex">
                <Modal
                  open={showSignInModalNotif}
                  onClose={handleCloseSignInModalNotif}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="modal-notification-style">
                    <div className="flex justify-center">
                      <svg
                        width="70"
                        height="70"
                        viewBox="0 0 70 70"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="35" cy="35" r="35" fill="#F95C3D" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.375 38.5C32.375 39.9497 33.5503 41.125 35 41.125C36.4497 41.125 37.625 39.9497 37.625 38.5L37.625 21C37.625 19.5503 36.4497 18.375 35 18.375C33.5503 18.375 32.375 19.5503 32.375 21L32.375 38.5ZM32.375 48.9999C32.375 50.4497 33.5503 51.6249 35 51.6249C36.4497 51.6249 37.625 50.4497 37.625 48.9999V47.2499C37.625 45.8002 36.4497 44.6249 35 44.6249C33.5503 44.6249 32.375 45.8002 32.375 47.2499L32.375 48.9999Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      style={{
                        marginBottom: "10%",
                        marginTop: "5%",
                        textAlign: "center",
                      }}
                    >
                      Sign in to see Notifications
                    </Typography>
                    <div className="flex justify-center">
                      <button
                        type="button"
                        className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                        onClick={handleSignInButtonModalNotif}
                      >
                        Sign in
                      </button>
                      <button
                        type="button"
                        className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                        onClick={handleCancelButtonModalNotif}
                      >
                        Cancel
                      </button>
                    </div>
                  </Box>
                </Modal>
                <Box sx={{ flexGrow: 0 }}>
                  {!userInfo ? (
                    <></>
                  ) : (
                    <>
                      <div className="flex scale-125">
                        <Tooltip title="Notifications">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`rounded-lg cursor-pointer hover:bg-[#FFE4CC] active:scale-90 ${
                              isClickedNotif ? "bg-[#FFE4CC]" : "none"
                            }`}
                            onClick={handleOpenNotifMenu}
                          >
                            <circle
                              cx="15"
                              cy="15"
                              r="15"
                              //fill={isClicked ? "#FFE4CC" : "none"}
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.0556 6.01266C16.0556 5.74408 15.9444 5.48651 15.7465 5.2966C15.5486 5.10669 15.2802 5 15.0003 5C14.7205 5 14.4521 5.10669 14.2542 5.2966C14.0563 5.48651 13.9451 5.74408 13.9451 6.01266V6.77215H13.3574C12.2262 6.77208 11.1375 7.18571 10.313 7.92885C9.48839 8.67198 8.98995 9.68875 8.91908 10.7722L8.68587 14.3509C8.59695 15.7154 8.11954 17.0303 7.30564 18.1524C7.13747 18.3844 7.03472 18.6541 7.00737 18.9355C6.98003 19.2169 7.02902 19.5002 7.14959 19.758C7.27015 20.0158 7.45819 20.2393 7.69541 20.4067C7.93263 20.5741 8.21095 20.6798 8.50332 20.7134L12.0985 21.1266V22.2152C12.0985 22.9538 12.4042 23.6621 12.9484 24.1843C13.4926 24.7066 14.2307 25 15.0003 25C15.77 25 16.5081 24.7066 17.0523 24.1843C17.5965 23.6621 17.9022 22.9538 17.9022 22.2152V21.1266L21.4974 20.7124C21.7896 20.6787 22.0677 20.573 22.3048 20.4057C22.5418 20.2383 22.7298 20.015 22.8503 19.7573C22.9708 19.4997 23.0199 19.2165 22.9927 18.9353C22.9655 18.654 22.8629 18.3844 22.695 18.1524C21.8811 17.0303 21.4037 15.7154 21.3148 14.3509L21.0816 10.7732C21.011 9.68958 20.5127 8.67256 19.6881 7.92922C18.8635 7.18587 17.7747 6.7721 16.6433 6.77215H16.0556V6.01266ZM13.3574 8.29114C12.6288 8.29105 11.9276 8.55744 11.3965 9.03606C10.8654 9.51468 10.5444 10.1695 10.4988 10.8673L10.2666 14.4461C10.1593 16.0876 9.58484 17.6694 8.60568 19.0192C8.59351 19.036 8.58607 19.0555 8.58408 19.0759C8.5821 19.0962 8.58563 19.1167 8.59434 19.1354C8.60305 19.154 8.61664 19.1702 8.63379 19.1823C8.65094 19.1944 8.67106 19.2021 8.69221 19.2046L12.6356 19.6592C14.2068 19.8395 15.7939 19.8395 17.3651 19.6592L21.3085 19.2046C21.3296 19.2021 21.3497 19.1944 21.3669 19.1823C21.384 19.1702 21.3976 19.154 21.4063 19.1354C21.415 19.1167 21.4186 19.0962 21.4166 19.0759C21.4146 19.0555 21.4072 19.036 21.395 19.0192C20.4162 17.6693 19.8421 16.0875 19.7351 14.4461L19.5019 10.8673C19.4563 10.1695 19.1352 9.51468 18.6042 9.03606C18.0731 8.55744 17.3719 8.29105 16.6433 8.29114H13.3574ZM15.0003 23.481C14.2722 23.481 13.6813 22.9139 13.6813 22.2152V21.4557H16.3194V22.2152C16.3194 22.9139 15.7284 23.481 15.0003 23.481Z"
                              fill={isClickedNotif ? "#F95C3D" : "black"}
                            />
                          </svg>
                        </Tooltip>

                        {allNotif.total_unread > "99" ? (
                          <span className="relative right-4 flex h-4 w-4">
                            <span className="flex rounded-full h-4 w-4 bg-[#F95C3D] text-[8.5px] text-white justify-center items-center">
                              99+
                            </span>
                          </span>
                        ) : allNotif.total_unread > "0" ? (
                          <span className="relative right-4 flex h-4 w-4">
                            <span className="flex rounded-full h-4 w-4 bg-[#F95C3D] text-[10px] text-white justify-center items-center">
                              {allNotif.total_unread}
                            </span>
                          </span>
                        ) : (
                          <div className="mr-4"></div>
                        )}
                      </div>
                    </>
                  )}
                </Box>

                {/* Desktop */}
                <Box sx={{ flexGrow: 0 }} className="hidden lg:flex">
                  {!userInfo ? (
                    <Link to="/signin" className="mr-3 text-[#F95C3D]">
                      SIGN IN
                    </Link>
                  ) : (
                    <>
                      <Tooltip title="Open Settings">
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                          <SetProfilePicture />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                        className="hidden lg:flex"
                        PaperProps={{
                          sx: {
                            borderRadius: "0.5rem", // Change this value as needed
                          },
                        }}
                      >
                        {userInfo && dataUser && dataUser.is_admin && (
                          <MenuItem
                            key="admin page"
                            onClick={handleAdminPageClick}
                          >
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              Admin page
                            </Typography>
                          </MenuItem>
                        )}
                        <MenuItem key="profile" onClick={handleProfileMenu}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            Profile
                          </Typography>
                        </MenuItem>
                        <MenuItem key="sign out" onClick={toggleModal}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            Sign out
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </Box>

                {/* Mobile */}
                <Box sx={{ flexGrow: 0 }} className="flex lg:hidden">
                  {!userInfo ? (
                    <Link to="/signin" className="mr-3 text-[#F95C3D]">
                      SIGN IN
                    </Link>
                  ) : (
                    <>
                      <Tooltip title="Open Settings">
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                          <SetProfilePicture />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                        className="flex lg:hidden"
                        PaperProps={{
                          sx: {
                            borderRadius: "0.5rem", // Change this value as needed
                          },
                        }}
                      >
                        {userInfo && dataUser && dataUser.is_admin && (
                          <MenuItem
                            key="admin page"
                            onClick={handleAdminPageClick}
                          >
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              Admin page
                            </Typography>
                          </MenuItem>
                        )}
                        <MenuItem key="profile" onClick={handleProfileMenu}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            Profile
                          </Typography>
                        </MenuItem>
                        <MenuItem key="about us" onClick={handleAboutUsMenu}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            About us
                          </Typography>
                        </MenuItem>
                        <MenuItem
                          key="contact us"
                          onClick={handleContactUsMenu}
                        >
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            Contact us
                          </Typography>
                        </MenuItem>
                        <MenuItem key="sign out" onClick={toggleModal}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            Sign out
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </Box>
              </div>
            </Toolbar>

            <div className="chat-history-dropdown">
              {isChatOpen && (
                <ul className="dropdown-menu">
                  {allChat.map((conversation, index) => {
                    // console.log("chat id", conversation.chatid);
                    // console.log("chat name", conversation.name);
                    // console.log("chat msg", conversation.message);
                    return (
                      <li
                        key={conversation.chatid}
                        className="conversation-item"
                      >
                        <div className="table-row">
                          <div className="table-col col-20">
                            {conversation.name}
                          </div>
                          <div className="table-col col-75">
                            {conversation.message}
                          </div>
                          <div className="table-col col-5">
                            <ChatTwoToneIcon
                              className="direct-chat-icon"
                              style={{
                                marginTop: "2.8vh",
                                marginLeft: "3vh",
                                color: "black",
                                fontSize: "4.1vh",
                                marginRight: "1vh",
                              }}
                              onClick={() => handleOpenPersonalChat(index)}
                            />
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </Container>
        </AppBar>
      </div>

      {/* Modal Logout */}
      <Modal
        open={showSignOutModal}
        onClose={handleCloseSignOutModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <div className="flex justify-center">
            <svg
              className="text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </div>

          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure you want to sign out?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleSignOutMenu}
            >
              Sign out
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonSignOutModal}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={showSignInModal}
        onClose={handleCloseSignInModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Sign in to use this feature
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleSignInButtonModal}
            >
              Sign in
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModal}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default Header;
